import * as angular from 'angular';

export class ModalService {
    active(selector: string): boolean {
        return this.hasPlugin(this.getModal(selector));
    }

    show(selector: string): void {
        const modal = this.getModal(selector);

        // Need to wait for foundation to render the modal
        // This is done by checking the element for plugin data
        if (this.hasPlugin(modal) && !this.isOpen(modal)) {
            modal.foundation('open');
        }
    }

    private getModal(selector: string): JQuery {
        return angular.element(selector);
    }

    private hasPlugin(modal: JQuery): boolean {
        return modal.data('zfPlugin');
    }

    private isOpen(modal: JQuery): boolean {
        return angular.element(modal).is(':visible');
    }
}
